import React from 'react';

interface LineLayoutListIconProps {
  size?: number;
  color?: string;
}

export const LineLayoutListIcon: React.FC<LineLayoutListIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <mask id="path-1-inside-1_2364_2708" fill="white">
        <path d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4Z" />
      </mask>
      <path
        d="M4 3V5H20V3V1H4V3ZM21 4H19V10H21H23V4H21ZM20 11V9H4V11V13H20V11ZM3 10H5V4H3H1V10H3ZM4 11V9C4.55228 9 5 9.44771 5 10H3H1C1 11.6569 2.34315 13 4 13V11ZM21 10H19C19 9.44772 19.4477 9 20 9V11V13C21.6569 13 23 11.6569 23 10H21ZM20 3V5C19.4477 5 19 4.55229 19 4H21H23C23 2.34314 21.6569 1 20 1V3ZM4 3V1C2.34315 1 1 2.34315 1 4H3H5C5 4.55228 4.55228 5 4 5V3Z"
        fill={color}
        mask="url(#path-1-inside-1_2364_2708)"
      />
      <mask id="path-3-inside-2_2364_2708" fill="white">
        <path d="M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14Z" />
      </mask>
      <path
        d="M4 13V15H20V13V11H4V13ZM21 14H19V20H21H23V14H21ZM20 21V19H4V21V23H20V21ZM3 20H5V14H3H1V20H3ZM4 21V19C4.55228 19 5 19.4477 5 20H3H1C1 21.6569 2.34315 23 4 23V21ZM21 20H19C19 19.4477 19.4477 19 20 19V21V23C21.6569 23 23 21.6569 23 20H21ZM20 13V15C19.4477 15 19 14.5523 19 14H21H23C23 12.3431 21.6569 11 20 11V13ZM4 13V11C2.34315 11 1 12.3431 1 14H3H5C5 14.5523 4.55228 15 4 15V13Z"
        fill={color}
        mask="url(#path-3-inside-2_2364_2708)"
      />
    </svg>
  );
};
